export default __webpack_public_path__ + "static/media/check.9ba1a20a.svg";